import axios from 'App/axios';
import {
  DateRangeType,
  Sort,
  TransactionDetailsType,
  TransactionObjectInterface,
  TransactionStatusType,
} from 'commons/types';

type GetTransactionDetailType = (
  orderId: string,
) => Promise<TransactionDetailsType>;

const getTransactionDetails: GetTransactionDetailType = async (
  orderId: string,
) => {
  const response = await axios.get(`/admin/transactions/${orderId}`);
  return response.data;
};

type GetTransactionsResponse = {
  transactions: TransactionObjectInterface[];
  page: number;
  itemsPerPage: number;
  itemsCount: number;
};

type GetTransactionsType = ({
  page,
  search,
  status,
  dateRange,
  fromDate,
  toDate,
  hasChargeback,
  items,
  sort,
}: {
  page: number;
  search?: string;
  status?: string;
  dateRange?: DateRangeType;
  fromDate?: string;
  toDate?: string;
  hasChargeback?: boolean;
  items?: number;
  sort?: Sort;
}) => Promise<GetTransactionsResponse>;

const getTransactions: GetTransactionsType = async ({
  page,
  search,
  status,
  dateRange,
  fromDate,
  toDate,
  hasChargeback,
  items,
  sort,
}) => {
  const params = {
    page,
    items,
    search: search || undefined,
    status: status || undefined,
    range: dateRange || undefined,
    from_date: fromDate || undefined,
    to_date: toDate || undefined,
    has_chargeback: hasChargeback,
    sort: sort || undefined,
  };

  const response = await axios.get(`/admin/transactions`, {
    params,
  });
  return response.data;
};

type GetHasTransactionsResponse = {
  hasTransactions: boolean;
};

type GetHasTransactionsType = (params?: {
  status?: TransactionStatusType[];
}) => Promise<GetHasTransactionsResponse>;

const getHasTransactions: GetHasTransactionsType = async (params) => {
  const { status } = params ?? {};
  const queryParams = {
    status: status?.join(',') || undefined,
  };
  const response = await axios.get(`/admin/transactions/exists`, {
    params: queryParams,
  });
  return response.data;
};

interface TransactionsServiceInterface {
  getTransactionDetails: GetTransactionDetailType;
  getTransactions: GetTransactionsType;
  getHasTransactions: GetHasTransactionsType;
}

const transactionsService: TransactionsServiceInterface = {
  getTransactionDetails,
  getTransactions,
  getHasTransactions,
};

export default transactionsService;
